import React, {PureComponent as Component} from 'react'; 
import ShowProfile from "../../../Controllers/Dashboard/ShowProfile";
import ShowInvertFriend from "../../Friend/Controllers/ShowInvertFriend";
import FriendState from "./All/FriendState";
import {MCbrowser} from "../../../Context/browserContext";
import CityMember from "./CityMember";
import OstanMember from "./OstanMember";
import Follower from "./Follower";
import Following from "./Following";

var fs =new FriendState();

class  Connection   extends Component{

    constructor(props) {
        super(props);
        this.isAlive = true;

        this.props=props;
    }



    componentDidMount(){
        let page = this.context.page;
        this.context.page.pageTitle.setTitle("دوستان");
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!prevState.loaded) {
            if (this.context.page.pageBreadcrumbs.current != null) {
                this.context.page.pageBreadcrumbs.current.setCurrent("connection");
                this.context.page.pageBreadcrumbs.current.show();
            }
        }
    }


    render() {

        return (
            <div className="row">
                <main className="col col-xl-9 order-xl-2 col-lg-12 order-lg-1 col-md-12 col-sm-12 col-12">
                    <div className="box shadow-sm border rounded bg-white mb-3 osahan-share-post">
                        <h5 className="pl-3 pt-3 pr-3 border-bottom mb-0 pb-3">
                            درخواست های آشنایان
                        </h5>
                        <ul className="nav border-bottom osahan-line-tab" id="myTab" role="tablist">
                            <li className="nav-item">
                                <a className="nav-link active" id="home-tab" data-toggle="tab" href="#followerCnl1" role="tab"
                                   aria-controls="home" aria-selected="true">
                                    بازدید کننده ( فالور )
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" id="profile-tab" data-toggle="tab" href="#followingCnl1" role="tab"
                                   aria-controls="profile" aria-selected="false">
                                     دوستان
                                    ( فالوینگ )
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" id="contact-tab" data-toggle="tab" href="#cityCnl1" role="tab"
                                   aria-controls="contact" aria-selected="false">
                                    همشهری ها
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" id="type-tab" data-toggle="tab" href="#ostanCnl1" role="tab"
                                   aria-controls="type" aria-selected="false">
                                   هم استانی ها
                                </a>
                            </li>
                        </ul>
                        <div className="tab-content" id="myTabContent">
                            <div className="tab-pane fade show active" id="followerCnl1" role="tabpanel" aria-labelledby="home-tab">
                                <Follower />
                            </div>
                            <div className="tab-pane fade" id="followingCnl1" role="tabpanel" aria-labelledby="profile-tab">
                                <Following />
                            </div>
                            <div className="tab-pane fade" id="cityCnl1" role="tabpanel" aria-labelledby="contact-tab">
                                <CityMember />
                            </div>
                            <div className="tab-pane fade" id="ostanCnl1" role="tabpanel" aria-labelledby="type-tab">
                                <OstanMember />
                            </div>
                        </div>
                    </div>
                </main>
                <aside className="col col-xl-3 order-xl-2 col-lg-12 order-lg-2 col-12">
                    <ShowProfile  />
                    <ShowInvertFriend />
                </aside>
            </div>
        );
    }

    destroy() {
        if (!this.isAlive) {
            return;
        }

        this.isAlive = false;
    }

    componentWillUnmount() {
        this.destroy();
    }
}

Connection.contextType = MCbrowser;

export default Connection;
